export const REQUEST_TYPE_OPTIONS = [
  {
    value: 'IMMEDIATE',
    label: 'Immediate',
  },
  {
    value: 'SCHEDULED',
    label: 'Scheduled',
  },
];

export const FREQUENCY_OPTIONS = [
  {
    value: 'WEEKLY',
    label: 'Weekly',
  },
  {
    value: 'BIWEEKLY',
    label: 'Bi-weekly',
  },
  {
    value: 'MONTHLY',
    label: 'Monthly',
  },
];
const WEEK_DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
export const START_DATE = new Date();
export const WEEK_DAYS_OPTIONS = Array(7).fill().map((val, key) => ({ value: key + 1, label: WEEK_DAYS[key] }));
export const MONTH_DAYS_OPTIONS = Array(31).fill().map((val, key) => ({ value: key + 1, label: key + 1 }));
export const EMPTY_BAG_VALUE = 'T';
